import BrowserActionTypes from './types'

const initialState = {
  browserToken: '',
  isBrowserToken: false,
  browserTokenError: false,
}

const browserTokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case BrowserActionTypes.SET_BROWSER_TOKEN: {
      return { ...state, browserToken: action.payload, isBrowserToken: true }
    }

    case BrowserActionTypes.SET_BROWSER_TOKEN_ERROR: {
      return {
        ...state,
        browserTokenError: action.payload,
      }
    }

    default:
      return state
  }
}

export default browserTokenReducer
